/**
 * Brand — edit company name and contact details for your domain.
 */

export const BRAND = {
  name: 'SKAARAPPS',
  displayName: 'SKAARAPPS',
  nameLower: 'skaarapps',
  tagline: 'IT Solutions and Services for Business',

  copyrightYear: new Date().getFullYear(),
  logoAlt: 'SKAARAPPS logo',

  metaDescription:
    'IT solutions and services for business: cloud, security, managed services, and digital transformation.',

  contact: {
    email: 'admin@skaarapps.com',
    phone: '+1 (555) 000-0000',
    city: 'United States',
  },
} as const;

/** U.K. Builders — testimonial / project attribution */
export const UK_BUILDERS = {
  ownerName: 'Pintu P.',
  company: 'U.K. Builders, LLC',
  roleTitle: 'Owner & President',
  region: 'Houston, TX',
} as const;

/** Neon Verse Studio — testimonial / project attribution */
export const NEON_VERSE_STUDIO = {
  ownerName: 'Pat N.',
  company: 'Neon Verse Studio',
  roleTitle: 'Founder',
  region: 'Nashville, TN',
} as const;

export const BRAND_NAME = BRAND.name;
export const BRAND_DISPLAY_NAME = BRAND.displayName;
export const BRAND_TAGLINE = BRAND.tagline;
